import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import http from "../services/http";
import GetStorage from "../services/Storage";
import moment from "moment";
import polygon from "../assets/images/Polygon 56.png";
import { SpinnerCircular } from "spinners-react";
import Dropdown from "react-bootstrap/Dropdown";
import dots from "../assets/images/dots.svg";
import dropdownpic from "../assets/images/dropdown.png";
import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";


function SwimmerLocker(props) {
  const token = GetStorage.get("xAuthToken");

  const [key, setKey] = useState("original");
  const [originalVideo, setOriginalVideo] = useState([]);
  const [evoOrders, setEvoOrders] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [category, setCotegory] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [lastPageRecordCount, setLastPageRecordCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const recordsPerPage = 7;
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedVideoIds, setSelectedVideoIds] = useState([]);
  const [sendLinkLoading, setSendLinkLoading] = useState(false);
  let pagesVisited = pageNumber * recordsPerPage;

  const originalPageRows = originalVideo.slice(
    pagesVisited,
    pagesVisited + recordsPerPage
  );
  const allOriginalPageSelected =
    originalPageRows.length > 0 &&
    originalPageRows.every((row) => selectedVideoIds.includes(row.id));

  const { id, name, swimmer,teamId } = location.state;

  const formatIsoUtc = (value) => {
    if (!value) return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const m = moment.utc(value);
    return m.isValid()
      ? m.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      : moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  };

  const toggleVideoSelect = (videoId) => {
    setSelectedVideoIds((prev) =>
      prev.includes(videoId) ? prev.filter((x) => x !== videoId) : [...prev, videoId]
    );
  };

  const toggleSelectAllOriginalPage = () => {
    const pageIds = originalPageRows.map((row) => row.id);
    if (allOriginalPageSelected) {
      setSelectedVideoIds((prev) => prev.filter((vid) => !pageIds.includes(vid)));
    } else {
      setSelectedVideoIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const handleSendSelectedVideos = () => {
    if (key !== "original" || selectedVideoIds.length === 0) return;
    const videos = [];
    for (const vid of selectedVideoIds) {
      const item = originalVideo.find((v) => v.id === vid);
      if (!item) continue;
      const swimmerIdValue = item.swimmer_id ?? swimmer?.id ?? id;
      videos.push({
        id: item.id,
        swimmer_id: String(swimmerIdValue),
        created_at: formatIsoUtc(item.created_at),
        timestamp: formatIsoUtc(
          item.timestamp ?? item.updated_at ?? item.created_at
        ),
      });
    }
    if (videos.length === 0) {
      showToast("error", "Could not build video payload.");
      return;
    }
    setSendLinkLoading(true);
    http
      .post(`api/admin/swimmer/share-selected-videos?token=${token}`, {
        videos,
      })
      .then((res) => {
        showToast(
          "success",
          res.data?.message || "Share link request sent successfully."
        );
        setSelectedVideoIds([]);
      })
      .catch((err) => {
        const msg =
          err.response?.data?.message ||
          (err.response?.data?.errors &&
            Object.values(err.response.data.errors).flat().join(" ")) ||
          "Failed to send link.";
        showToast("error", msg);
      })
      .finally(() => setSendLinkLoading(false));
  };

  useEffect(() => {
    SwimmerVideos();
    categoryfunction();
  }, []);

  const SwimmerVideos = async () => {
    setLoading(true);

    http
      .get(`api/admin/swimmer/${id}/locker?token=${token}`)
      .then((res) => {
        console.log("reponse in swimmer", res.data);
        setOriginalVideo(res.data);
        setLastPageRecordCount(res.data.length % recordsPerPage == 0 ? recordsPerPage : res.data.length % recordsPerPage);
        setTotalPageCount(Math.ceil(res.data.length / recordsPerPage));
        setTotalRecords(res.data.length)
        setPageNumber(0)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const InProgress = (k) => {
    setKey(k);
    setSelectedVideoIds([]);
    switch (k) {
      case "original":
        setLoading(true);

        http
          .get(`api/admin/swimmer/${id}/locker?token=${token}`)

          .then((res) => {
            console.log("reponse in swimmer tab", res.data);
            setOriginalVideo(res.data);
            setLastPageRecordCount(res.data.length % recordsPerPage == 0 ? recordsPerPage : res.data.length % recordsPerPage);
            setTotalPageCount(Math.ceil(res.data.length / recordsPerPage));
            setTotalRecords(res.data.length)
            setPageNumber(0)
            setLoading(false);
          })
          .catch((error) => {
            console.log("errpr", error);
            setLoading(false);
          });
        break;

      default:
        setLoading(true);

        http

          .get(`api/admin/swimmer/${id}/locker/orders?token=${token}`)
          .then((res) => {
            console.log("evo orders", res.data);
            setEvoOrders(res.data);
            setLastPageRecordCount(res.data.length % recordsPerPage == 0 ? recordsPerPage : res.data.length % recordsPerPage);
            setTotalPageCount(Math.ceil(res.data.length / recordsPerPage));
            setTotalRecords(res.data.length)
            setPageNumber(0)
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
    }
  };
  const categoryfunction = async () => {
    setLoading(true);

    http
      .get(`api/category?token=${token}`)
      .then((res) => {
        console.log("reponse category=====>", res.data);
        setCotegory(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error in category", error);
        setLoading(false);
      });
  };
  const handleChanges = (event) => {
    console.log("on change value", event.target.value);
    let path =
      key === "original"
        ? `api/admin/swimmer/${id}/locker?token=${token}`
        : `api/admin/swimmer/${id}/locker/orders?token=${token}`;
    if (event.target.value > 0) {
      path += `&category=${event.target.value}`;
    }
    setLoading(true);
    setSelectedVideoIds([]);
    http
      .get(path)
      .then((res) => {
        if (key === "original") {
          console.log("and key ===>>", key);
          setOriginalVideo(res.data);
          console.log("video---->", res.data);
        } else {
          setEvoOrders(res.data);
          console.log("evo---->", res.data);
        }
        setLoading(false);
        setLastPageRecordCount(res.data.length % recordsPerPage == 0 ? recordsPerPage : res.data.length % recordsPerPage);
        setTotalPageCount(Math.ceil(res.data.length / recordsPerPage));
        setTotalRecords(res.data.length)
        setPageNumber(0)
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
        setLoading(false);
      });
  };
  const WatchVideoCode = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const WatchVideoEvo = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <>
      <body>
        <ToastContainer />
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                    onClick={() => navigate(`/teamShark/${teamId}`,{ state: { previousPath: location.pathname }})}
                  >
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>

                  <h1>{name}</h1>
                </div>
                <DropdownRight />
              </div>
            </header>
            <div className="dashbord_content">
              <div className="analysts-wraper-head team_edit">
                <div className="personal_and_bank_info Analysts_tabs Intermediate">
                  <div
                    className="map_btn Edit_Setting d-flex align-items-center mb-0 flex-wrap"
                    style={{ marginTop: -15 }}
                  >
                    <div className="form-group icon  mb-0 mr-2">
                      <select
                        onChange={handleChanges}
                        name="Team"
                        className="form-control custom_input w_230 mb-0"
                        key={key}
                      >
                        <option value="0" selected>
                          Search by stroke
                        </option>
                        {category?.map((item, i) => (
                          <option key={i} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <div className="img_icon">
                        {" "}
                        <img src={dropdownpic} alt="" />{" "}
                      </div>
                    </div>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/editDetails"
                      state={{
                        swimmer: swimmer,
                      }}
                    >
                      <button className="them_btn" type="button">
                        Edit Details
                      </button>{" "}
                    </Link>
                    {key === "original" && (
                      <button
                        className="them_btn ml-2"
                        type="button"
                        style={{
                          marginLeft: 8,
                          opacity: selectedVideoIds.length === 0 || sendLinkLoading ? 0.5 : 1,
                          cursor: selectedVideoIds.length === 0 || sendLinkLoading ? "not-allowed" : "pointer",
                        }}
                        disabled={
                          selectedVideoIds.length === 0 || sendLinkLoading
                        }
                        onClick={handleSendSelectedVideos}
                      >
                        {sendLinkLoading ? "Sending…" : "Send Link"}
                      </button>
                    )}
                  </div>

                  <Tabs
                    activeKey={key}
                    onSelect={(k) => InProgress(k)}
                    style={{
                      alignItems: "center",
                      width: 400,
                      borderRadius: 5,
                      backgroundColor: "#f6f6f6",
                      padding: 2,
                    }}
                    defaultActiveKey="original"
                    id="uncontrolled-tab-example"
                    className="mb-3 nav nav-pills border-bottom-0"
                  >
                    <Tab
                      eventKey="original"
                      title="Original Video"
                      style={{ marginTop: 40 }}
                    >
                      <div class="tab-content" id="pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="pills-All"
                          role="tabpanel"
                          aria-labelledby="pills-All-tab"
                        >
                          <div class="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                            <table class="table table-borderless table-responsive-lg original-video-table">
                              <thead>
                                <tr>
                                  <th scope="col" className="locker-select-col">
                                    <label className="check_box">
                                      <input
                                        type="checkbox"
                                        checked={allOriginalPageSelected}
                                        ref={(el) => {
                                          if (!el) return;
                                          el.indeterminate =
                                            originalPageRows.some((row) =>
                                              selectedVideoIds.includes(row.id)
                                            ) && !allOriginalPageSelected;
                                        }}
                                        onChange={toggleSelectAllOriginalPage}
                                        aria-label="Select all videos on this page"
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                  </th>
                                  <th scope="col" class=" w_150 pl_25 text-center">
                                    Cam1
                                  </th>
                                  <th scope="col" class=" w_150 pl_25 text-center">
                                    Cam2
                                  </th>
                                  <th scope="col" class="w_120 ">
                                    Views Count
                                  </th>
                                  {/* <th scope="col" class="w_320 ">
                                    Title
                                  </th> */}
                                  <th scope="col" class=" w_120 text-center">
                                    Stroke
                                  </th>
                                  {/* <th scope="col" class=" w_150">
                                    Duration
                                  </th> */}
                                  <th scope="col" class=" w_120 text-center">
                                    Date
                                  </th>
                                  {/* <th scope="col" class=" w_150">
                                    Action
                                  </th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      marginTop: 250,
                                      // backgroundColor: "#ffffffc2",
                                      marginLeft: 580,

                                      backgroundBlendMode: "overlay",
                                      zIndex: 100,
                                    }}
                                  >
                                    <SpinnerCircular size="15%" />
                                  </div>
                                ) : (
                                  <>
                                    {originalPageRows?.map((item) => (
                                      <tr key={item.id}>
                                        <td className="locker-select-col">
                                          <label className="check_box">
                                            <input
                                              type="checkbox"
                                              checked={selectedVideoIds.includes(
                                                item.id
                                              )}
                                              onChange={() =>
                                                toggleVideoSelect(item.id)
                                              }
                                            />
                                            <span className="checkmark"></span>
                                          </label>
                                        </td>
                                        <td className="">
                                          <Link
                                            style={{
                                              position: "relative", display: "block", width: "80%", height: "auto",margin: "0 auto" 
                                            }}
                                            to="/preview-video"
                                            state={{
                                              id: item.id,
                                              type:"original_video",
                                              name: item.outputFilenameCam1,
                                            }}
                                          >
                                           <div style={{ position: "relative", width: "100%", height: "auto" }}>
                                           <video style={{ width: "100%", height: "auto" }}>
                                              <source
                                                src={item.outputFilenameCam1}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt="Play"
                                              style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: 20,
                                                height: 20,
                                                pointerEvents: "none"
                                              }}
                                            />
                                          </div>
                                          </Link>
                                        </td>
                                        <td className="">
                                          <Link
                                            style={{
                                              position: "relative",display: "block", width: "80%", height: "auto",margin: "0 auto"  
                                            }}
                                            to="/preview-video"
                                            state={{
                                              id: item.id,
                                              type:"original_video",
                                              name: item.outputFilenameCam2,
                                            }}
                                          >
                                          <div style={{ position: "relative", width: "100%", height: "auto" }}>
                                            <video 
                                            //  width={100} 
                                            //  height={70}
                                             style={{ width: "100%", height: "auto" }}
                                            >
                                              <source
                                                src={item.outputFilenameCam2}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt="Play"
                                              style={{
                                                position: "absolute",
                                                // marginTop: 25,
                                                // marginLeft: -60,
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: 20,
                                                height: 20,
                                                pointerEvents: "none"
                                              }}
                                            />
                                          </div>

                                          </Link>
                                        </td>
                                        <td>
                                        <strong>Total Views : {item.total_views}</strong> <hr/>
                                        {Object.entries(item.viewer_counts).map(([type, count]) => (
                                          <div key={type}>
                                            {type}: {count}
                                          </div>
                                        ))}
                                        </td>
                                        {/* <td style={{ wordWrap: "break-word" }}>
                                          {item.outputFilenameCam1
                                            .split("/")
                                          [
                                            item.outputFilenameCam1.split("/")
                                              .length - 1
                                          ].toUpperCase()}
                                          <hr/>
                                          {item.outputFilenameCam2
                                            .split("/")
                                          [
                                            item.outputFilenameCam2.split("/")
                                              .length - 1
                                          ].toUpperCase()}
                                        </td> */}
                                        <td className="text-center">{item.stroke}</td>
                                        {/* <td>{item.duration}</td> */}
                                        <td className="text-center">
                                          {moment(item.created_at).format(
                                            "MMM Do YY"
                                          )}
                                        </td>
                                        {/* <td className="text-center">
                                      <div className="dropdown wraper_btn">
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            // className="btn dropdown-toggle"
                                            variant="success"
                                            id="dropdown-basic"
                                          >
                                            <img
                                              src={dots}
                                              className="img-fulid"
                                              alt="dropdown"
                                            />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            as="ul"
                                            className="dropul"
                                          >
                                            <Dropdown.Item
                                              as="li"
                                              onClick={() =>
                                                WatchVideoCode(
                                                  item.id,
                                                  "recording"
                                                )
                                              }
                                            >
                                              Show video
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </td> */}
                                      </tr>
                                    ))}
                                  </>
                                )}
                              </tbody>
                            </table>
                            {/*  <p class="text-table-show">
                              {" "}
                              Showing 8 out of 132 entries
                            </p> */}
                            <div className="pagination pg-width">
                              <div className="paginateText">
                                <p className="text-table-show">
                                  {" "}
                                  Showing{" "}
                                  {/* {pageNumber === totalPageCount - 1 ? lastPageRecordCount : recordsPerPage} out of{" "} */}
                                  {totalRecords != 0 ? (pageNumber === totalPageCount - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageRecordCount)) : (pagesVisited + 1 + '-' + (pagesVisited + recordsPerPage))) : 0} out of{" "}
                                  {totalRecords} entries
                                </p>
                              </div>
                              <div className="reactPaginate">
                                <ReactPaginate
                                  previousLabel={"<<"}
                                  nextLabel={">>"}
                                  pageCount={totalPageCount}
                                  onPageChange={changePage}
                                  containerClassName={"paginationBttns"}
                                  previousLinkClassName={"previousBttn"}
                                  nextLinkClassName={"nextBttn"}
                                  disabledClassName={"paginationDisabled"}
                                  activeClassName={"paginationActive"}
                                  forcePage={pageNumber}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>

                    <Tab
                      onSelect={InProgress}
                      eventKey="orders"
                      title="Evo Orders"
                      style={{ marginTop: 40 }}
                    >
                      <div class="tab-content" id="pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="pills-All"
                          role="tabpanel"
                          aria-labelledby="pills-All-tab"
                        >
                          <div class="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                            <table class="table table-borderless table-responsive-lg original-video-table">
                              <thead>
                                <tr>
                                  <th scope="col" class=" w_150 pl_25">
                                    Cam1
                                  </th>
                                  <th scope="col" class=" w_150 pl_25">
                                    Cam2
                                  </th>
                                  {/* <th scope="col" class="w_320 ">
                                    Title
                                  </th> */}
                                  <th scope="col" class=" w_120">
                                    Stroke
                                  </th>
                                  {/* <th scope="col" class=" w_150">
                                    Duration
                                  </th> */}
                                  <th scope="col" class=" w_120">
                                    Date
                                  </th>
                                  {/* <th scope="col" class=" w_150 pl_25">
                                    Action
                                  </th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      marginTop: 250,
                                      // backgroundColor: "#ffffffc2",
                                      marginLeft: 580,

                                      backgroundBlendMode: "overlay",
                                      zIndex: 100,
                                    }}
                                  >
                                    <SpinnerCircular size="15%" />
                                  </div>
                                ) : (
                                  <>
                                    {evoOrders.slice(pagesVisited, pagesVisited + recordsPerPage)?.map((item) => (
                                      <tr key={item.id}>
                                        <td className="pl_25">
                                          <Link
                                            style={{
                                              position: "relative",
                                            }}
                                            to="/preview-video"
                                            state={{
                                              id: item.id,
                                              type:"evo_order",
                                              name: item.outputFilenameCam1,
                                            }}
                                          >
                                            <video width={100} height={70}>
                                              <source
                                                src={item.outputFilenameCam1}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt=""
                                              style={{
                                                position: "absolute",
                                                marginTop: 25,
                                                marginLeft: -60,
                                                width: 20,
                                                height: 20,
                                              }}
                                            />
                                          </Link>
                                        </td>
                                        <td className="pl_25">
                                          <Link
                                            style={{
                                              position: "relative",
                                            }}
                                            to="/preview-video"
                                            state={{
                                              id: item.id,
                                              type:"evo_order",
                                              name: item.outputFilenameCam2,
                                            }}
                                          >
                                            <video width={100} height={70}>
                                              <source
                                                src={item.outputFilenameCam2}
                                              />
                                            </video>
                                            <img
                                              src={polygon}
                                              alt=""
                                              style={{
                                                position: "absolute",
                                                marginTop: 25,
                                                marginLeft: -60,
                                                width: 20,
                                                height: 20,
                                              }}
                                            />
                                          </Link>
                                        </td>
                                        {/* <td style={{ wordWrap: "break-word" }}>
                                          {item.outputFilenameCam1
                                            .split("/")
                                          [
                                            item.outputFilenameCam1.split("/")
                                              .length - 1
                                          ].toUpperCase()}
                                          <hr/>
                                          {item.outputFilenameCam2
                                            .split("/")
                                          [
                                            item.outputFilenameCam2.split("/")
                                              .length - 1
                                          ].toUpperCase()}
                                        </td>{" "} */}
                                        <td>{item.stroke}</td>
                                        {/* <td>{item.duration}</td> */}
                                        <td>
                                          {moment(item.created_at).format(
                                            "MMM Do YY"
                                          )}
                                        </td>
                                        {/* <td className="text-center">
                                          <div className="dropdown wraper_btn">
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                className="btn dropdown-toggle"
                                                variant="success"
                                                id="dropdown-basic"
                                              >
                                                <img
                                                  src={dots}
                                                  className="img-fulid"
                                                  alt="dropdown"
                                                />
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu
                                                as="ul"
                                                className="dropul"
                                              >
                                                <Dropdown.Item
                                                  as="li"
                                                  onClick={() =>
                                                    WatchVideoEvo(
                                                      item.id,
                                                      "order_pending"
                                                    )
                                                  }
                                                >
                                                  Show video
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                        </td> */}
                                      </tr>
                                    ))}
                                  </>
                                )}
                              </tbody>
                            </table>
                            {/*  <p class="text-table-show">
                          {" "}
                          Showing 8 out of 132 entries
                        </p> */}
                            <div className="pagination pg-width">
                              <div className="paginateText">
                                <p className="text-table-show">
                                  {" "}
                                  Showing{" "}
                                  {/* {pageNumber === totalPageCount - 1 ? lastPageRecordCount : recordsPerPage} out of{" "} */}
                                  {totalRecords != 0 ? (pageNumber === totalPageCount - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageRecordCount)) : (pagesVisited + 1 + '-' + (pagesVisited + recordsPerPage))) : 0} out of{" "}
                                  {totalRecords} entries
                                </p>
                              </div>
                              <div className="reactPaginate">
                                <ReactPaginate
                                  previousLabel={"<<"}
                                  nextLabel={">>"}
                                  pageCount={totalPageCount}
                                  onPageChange={changePage}
                                  containerClassName={"paginationBttns"}
                                  previousLinkClassName={"previousBttn"}
                                  nextLinkClassName={"nextBttn"}
                                  disabledClassName={"paginationDisabled"}
                                  activeClassName={"paginationActive"}
                                  forcePage={pageNumber}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*   <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-lg">
                          <thead>
                            <tr>
                              <th scope="col" className=" w_150 pl_25">
                                Video
                              </th>
                              <th scope="col" className="w_556 ">
                                Title
                              </th>
                              <th scope="col" className=" w_150">
                                Stroke Type
                              </th>
                              <th scope="col" className=" w_150">
                                Duration
                              </th>
                              <th scope="col" className=" w_150">
                                Date Filmed
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {evoOrders?.map((item) => (
                              <tr key={item.id}>
                                <td className="pl_25">
                                  <video
                                    // controls
                                    width={100}
                                    height={70}
                                    src={item.outputFilenameCam2}
                                  />
                                </td>
                                <td>
                                  {
                                    item.outputFilenameCam1.split("/")[
                                      item.outputFilenameCam1.split("/")
                                        .length - 1
                                    ]
                                  }
                                </td>{" "}
                                <td>{item.stroke}</td>
                                <td>1m 24s</td>
                                <td>
                                  {moment(item.created_at).format("MMM Do YY")}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div> */}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default SwimmerLocker;
